/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Open_CameraInputs */

const vi_mobile_open_camera = /** @type {(inputs: Mobile_Open_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở camera quét`)
};

/**

* @param {Mobile_Open_CameraInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const mobile_open_camera = /** @type {((inputs?: Mobile_Open_CameraInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Open_CameraInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_mobile_open_camera(inputs)
});